import './SearchInput.scss'

import classNames from 'classnames'
import SvgClose from 'icons/Close'
import SvgSearch from 'icons/Search'
import KeyCode from 'lib/util/KeyCode'
import React, { InputHTMLAttributes, KeyboardEvent } from 'react'
import { useTranslation } from 'react-i18next'

export interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string
  input: string
  clearSearchInput: ()=> void
  setInput: (value: string)=> void
}

export default function SearchInput(props: SearchInputProps) {
  const { className, input, clearSearchInput, setInput, ...otherProps } = props
  const [t] = useTranslation()

  const mergedContainerClass = classNames('search-input__container', { 'search-input__container--active': !!input })
  const mergedClassName = classNames('search-input', className)

  function onKeyDown(event: KeyboardEvent) {
    if (event.keyCode === KeyCode.ESC) {
      clearSearchInput()
    }
  }

  return (
    <div className={mergedContainerClass}>
      <SvgSearch className="search-input__search-icon" />
      <input
        type="text"
        className={mergedClassName}
        placeholder={t('home.search.placeholder')}
        value={input}
        onChange={e => setInput(e.currentTarget.value)}
        onKeyDown={onKeyDown}
        {...otherProps}
      />
      {!!input && <SvgClose className="search-input__close-icon" onClick={clearSearchInput} />}
    </div>
  )
}
